import ConsensusProvider from "../provider/ConsensusProvider";
import {
  SET_CONTRIES_COSENSUS,
  SET_DATA_CONSENSUS,
  SET_DATA_CONSENSUS_RESULT,
  SET_URL_EXPORT,
  SET_DATA_FE_FORECAST,
  SET_DATA_LAST_TRIMESTER,
  SET_BACKTESTING,
  SET_BACKTESTING_DEVIATION,
  SET_BACKTESTING_DEVIATION_ML
} from "./ConsensusMutationTypes";
import apolloClient from "@/apollo";

export default {
  state: {
    contries_consensus: [],
    dataConsensus: "[]",
    dataConsensusResult: [],
    urlExportConsensus: "",
    fe_forecast: "[]",
    last_trimester: "[]",
    backtesting: "[]",
    backtestingDeviation: null,
    backtestingDeviationMl:null
  },
  getters: {
    getcontriesConsensus: (state) => {
      return state.contries_consensus;
    },
    getdataConsensus: (state) => {
      return state.dataConsensus;
    },
    getdataConsensusResult: (state) => {
      return state.dataConsensusResult;
    },
    getUrlExportConsensus: (state) => {
      return state.urlExportConsensus;
    },
    getFeForecast: (state) => {
      return state.fe_forecast;
    },
    getLastSemester: (state) => {
      return state.last_trimester;
    },
    getBackteting: (state) => {
      return state.backtesting;
    },
    getBacktetingDeviation: (state) => {
      return state.backtestingDeviation;
    },
    getBacktetingDeviationMl: (state) => {
      return state.backtestingDeviationMl;
    },
  },
  actions: {
    setCountriesConsensus({ commit }) {
      ConsensusProvider.getCountriesConsensus().then((data) => {
        commit(SET_CONTRIES_COSENSUS, data.data.country);
      });
    },
    setDataConsensus({ commit }, country) {
      apolloClient.cache.reset();
      commit(SET_DATA_CONSENSUS, "[]");
      ConsensusProvider.gerData(country).then((data) => {
        commit(
          SET_DATA_CONSENSUS,
          data.data.consensus.data.replaceAll("\\", "")
        );
      });
    },
    setDataConsensusResult({ commit }, country) {
      apolloClient.cache.reset();
      commit(SET_DATA_CONSENSUS_RESULT, "[]");
      ConsensusProvider.gerDataResult(country).then((data) => {
        commit(
          SET_DATA_CONSENSUS_RESULT,
          data.data.consensusResults.data.replaceAll("\\", "")
        );
      });
    },
    exportExcelConsensus({ commit }, payload) {
      commit(SET_URL_EXPORT, "");
      ConsensusProvider.ApplyExportExcelConsensus(
        payload.headers,
        payload.data,
        payload.headers2,
        payload.data2
      ).then((data) => {
        commit(SET_URL_EXPORT, data.data.exportExcelConsensus.url);
      });
    },
    setDataFeForecast({ commit }, country) {
      apolloClient.cache.reset();
      commit(SET_DATA_FE_FORECAST, "[]");
      ConsensusProvider.gerDataFeForecast(country).then((data) => {
        commit(
          SET_DATA_FE_FORECAST,
          data.data.teForecast.data.replaceAll("\\", "")
        );
      });
    },
    setDataLastSemester({ commit }, country) {
      apolloClient.cache.reset();
      commit(SET_DATA_LAST_TRIMESTER, "[]");
      ConsensusProvider.getDataLastSemester(country).then((data) => {
        commit(
          SET_DATA_LAST_TRIMESTER,
          data.data.lastSemester.data.replaceAll("\\", "")
        );
      });
    },
    setDataBacktesting({ commit }, country) {
      apolloClient.cache.reset();
      commit(SET_BACKTESTING, "[]");
      ConsensusProvider.getDataBacktesting(country).then((data) => {
        commit(
          SET_BACKTESTING,
          data.data.backtesting.data.replaceAll("\\", "")
        );
      });
    },
    setDataBacktestingDeviation({ commit }, data) {
      apolloClient.cache.reset();
      commit(SET_BACKTESTING_DEVIATION, null);
      ConsensusProvider.getDataBacktestingDeviation(
        data.country,
        data.variable
      ).then((data) => {
        commit(SET_BACKTESTING_DEVIATION, data.data.backtestinDeviation.result);
      });
    },
    setDataBacktestingDeviationMl({ commit }, data) {
      apolloClient.cache.reset();
      commit(SET_BACKTESTING_DEVIATION, null);
      ConsensusProvider.getDataBacktestingDeviationMl(
        data.country,
        data.variable
      ).then((data) => {
        commit(SET_BACKTESTING_DEVIATION_ML, data.data.backtestinDeviationMl.result);
      });
    },
  },
  mutations: {
    [SET_CONTRIES_COSENSUS](state, data) {
      state.contries_consensus = data;
    },
    [SET_DATA_CONSENSUS](state, data) {
      state.dataConsensus = data;
    },
    [SET_DATA_CONSENSUS_RESULT](state, data) {
      state.dataConsensusResult = data;
    },
    [SET_URL_EXPORT](state, data) {
      state.urlExportConsensus = data;
    },
    [SET_DATA_FE_FORECAST](state, data) {
      state.fe_forecast = data;
    },
    [SET_DATA_LAST_TRIMESTER](state, data) {
      state.last_trimester = data;
    },
    [SET_BACKTESTING](state, data) {
      state.backtesting = data;
    },
    [SET_BACKTESTING_DEVIATION](state, data) {
      state.backtestingDeviation = data;
    },
    [SET_BACKTESTING_DEVIATION_ML](state, data){
      state.backtestingDeviationMl = data;
    }
  },
};
